import * as React from 'react';
import { useSelector } from 'react-redux';
import { HeartFavoriteSecondaryButton } from '../../components/Favorite/HeartFavoriteSecondaryButton';
import { Header as HeaderComponent } from '../../components/Header';
import { getDisplayName } from '../../selectors/newbuilding';
import { HeaderCall } from '../Call/HeaderCall';
import { HeaderCallbackButton } from '../CallbackButton';
import { FavoriteContainer } from '../Favorite';
import { FlatViewOrderHeaderPopupContainer } from '../FlatViewOrderHeaderPopup';

interface IHeaderProps {
  isFixed: boolean;
}

export const Header = ({ isFixed }: IHeaderProps) => {
  const name = useSelector(getDisplayName);

  return (
    <HeaderComponent
      name={name}
      isFixed={isFixed}
      call={<HeaderCall eventAction="Open_jk_card_blockStickytop" />}
      flatViewOrder={<FlatViewOrderHeaderPopupContainer />}
      callback={<HeaderCallbackButton />}
      favorite={<FavoriteContainer button={HeartFavoriteSecondaryButton} />}
    />
  );
};
